import { FC, useContext } from 'react';
import { TextInput } from '@carbon/react';
import { NumericFormat } from 'react-number-format';

import { AfeWizardCtx } from '../context';
import styles from './well-information-step.module.scss';

/**
 * D&C Information sub-section. Renders Planned Lateral Length and
 * Planned Total Depth text inputs. Shared by both Existing and Generic forms.
 * @return {JSX.Element} The D&C fields
 */
const DnCSection: FC = () => {
  const { form } = useContext(AfeWizardCtx)!;

  return (
    <div>
      <h3 className={styles.sectionHeading}>
        Drilling & Completion Information
      </h3>
      <div className={styles.fieldRow}>
        <form.Field name="plannedLateralLength">
          {(field) => (
            <NumericFormat
              type="text"
              customInput={TextInput}
              id="planned-lateral-length"
              labelText="Planned Lateral Length *"
              thousandSeparator
              allowNegative={false}
              value={field.state.value === null ? '' : field.state.value}
              onValueChange={(values) => {
                field.handleChange(
                  values.value !== '' ? Number(values.value) : null
                );
              }}
              className={styles.field}
            />
          )}
        </form.Field>
        <form.Field name="plannedTvd">
          {(field) => (
            <NumericFormat
              type="text"
              customInput={TextInput}
              id="planned-tvd"
              labelText="Planned True Vertical Depth *"
              thousandSeparator
              allowNegative={false}
              value={field.state.value === null ? '' : field.state.value}
              onValueChange={(values) => {
                field.handleChange(
                  values.value !== '' ? Number(values.value) : null
                );
              }}
              className={styles.field}
            />
          )}
        </form.Field>
      </div>
    </div>
  );
};

export { DnCSection };
